// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
import axios from 'axios'


import mixinCommon from '@/mixin/common';
import {
  configNginxUrl,
  declareNginxUrl,
  dataNginxUrl,
  spreadJsKey
} from '@/api/baseUrl'
import commonApi from '@/api/common';
import moment from 'moment';
import '@/plugins/dialogDrag/dialogDrag';
import fullScreenMessage from '@/plugins/spreadJs/fullScreen/message/src/main.js';
import bus from '@/plugins/bus';
Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.prototype.$fullScreenMessage = fullScreenMessage;
Vue.prototype.$bus = bus;
Vue.prototype.$axios = axios;
Vue.mixin(mixinCommon)
Vue.mixin({
  data () {
    return {
      configNginxUrl: configNginxUrl, //configure接口地址
      declareNginxUrl: declareNginxUrl, //declare接口地址
      dataNginxUrl: dataNginxUrl, //data接口地址
      spreadJsKey: spreadJsKey, //spreadJs授权码
      commonApi: commonApi, //公用接口
      axios: axios,
      moment: moment, //时间格式化
    }
  },
});

new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js